//# sourceMappingURL=capacity.mjs.map
/// <reference types="./capacity.d.mts" />
import * as $llm_capacity from "../../data_types/data/llm_capacity.mjs";
import { RateLimits } from "../../data_types/data/llm_capacity.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $llm_usage from "../data/llm_usage.mjs";
import {
  toList,
  Empty as $Empty,
  CustomType as $CustomType,
  divideFloat,
  divideInt,
  isEqual,
} from "../gleam.mjs";

export class Scenario extends $CustomType {
  constructor(servers, workers, answer_messages, proposals_in_parallel, questions_per_proposal, seconds_per_question) {
    super();
    this.servers = servers;
    this.workers = workers;
    this.answer_messages = answer_messages;
    this.proposals_in_parallel = proposals_in_parallel;
    this.questions_per_proposal = questions_per_proposal;
    this.seconds_per_question = seconds_per_question;
  }
}
export const Scenario$Scenario = (servers, workers, answer_messages, proposals_in_parallel, questions_per_proposal, seconds_per_question) =>
  new Scenario(servers,
  workers,
  answer_messages,
  proposals_in_parallel,
  questions_per_proposal,
  seconds_per_question);
export const Scenario$isScenario = (value) => value instanceof Scenario;
export const Scenario$Scenario$servers = (value) => value.servers;
export const Scenario$Scenario$0 = (value) => value.servers;
export const Scenario$Scenario$workers = (value) => value.workers;
export const Scenario$Scenario$1 = (value) => value.workers;
export const Scenario$Scenario$answer_messages = (value) =>
  value.answer_messages;
export const Scenario$Scenario$2 = (value) => value.answer_messages;
export const Scenario$Scenario$proposals_in_parallel = (value) =>
  value.proposals_in_parallel;
export const Scenario$Scenario$3 = (value) => value.proposals_in_parallel;
export const Scenario$Scenario$questions_per_proposal = (value) =>
  value.questions_per_proposal;
export const Scenario$Scenario$4 = (value) => value.questions_per_proposal;
export const Scenario$Scenario$seconds_per_question = (value) =>
  value.seconds_per_question;
export const Scenario$Scenario$5 = (value) => value.seconds_per_question;

export class WithinLimits extends $CustomType {}
export const LoadStatus$WithinLimits = () => new WithinLimits();
export const LoadStatus$isWithinLimits = (value) =>
  value instanceof WithinLimits;

export class Watch extends $CustomType {}
export const LoadStatus$Watch = () => new Watch();
export const LoadStatus$isWatch = (value) => value instanceof Watch;

export class NearLimit extends $CustomType {}
export const LoadStatus$NearLimit = () => new NearLimit();
export const LoadStatus$isNearLimit = (value) => value instanceof NearLimit;

export class LimitsUnknown extends $CustomType {}
export const LoadStatus$LimitsUnknown = () => new LimitsUnknown();
export const LoadStatus$isLimitsUnknown = (value) =>
  value instanceof LimitsUnknown;

export class ModelLoad extends $CustomType {
  constructor(model_alias, steps, deployments, requests_per_minute, input_tokens_per_minute, output_tokens_per_minute, limits, requests_pct, tokens_pct, input_tokens_pct, output_tokens_pct, status) {
    super();
    this.model_alias = model_alias;
    this.steps = steps;
    this.deployments = deployments;
    this.requests_per_minute = requests_per_minute;
    this.input_tokens_per_minute = input_tokens_per_minute;
    this.output_tokens_per_minute = output_tokens_per_minute;
    this.limits = limits;
    this.requests_pct = requests_pct;
    this.tokens_pct = tokens_pct;
    this.input_tokens_pct = input_tokens_pct;
    this.output_tokens_pct = output_tokens_pct;
    this.status = status;
  }
}
export const ModelLoad$ModelLoad = (model_alias, steps, deployments, requests_per_minute, input_tokens_per_minute, output_tokens_per_minute, limits, requests_pct, tokens_pct, input_tokens_pct, output_tokens_pct, status) =>
  new ModelLoad(model_alias,
  steps,
  deployments,
  requests_per_minute,
  input_tokens_per_minute,
  output_tokens_per_minute,
  limits,
  requests_pct,
  tokens_pct,
  input_tokens_pct,
  output_tokens_pct,
  status);
export const ModelLoad$isModelLoad = (value) => value instanceof ModelLoad;
export const ModelLoad$ModelLoad$model_alias = (value) => value.model_alias;
export const ModelLoad$ModelLoad$0 = (value) => value.model_alias;
export const ModelLoad$ModelLoad$steps = (value) => value.steps;
export const ModelLoad$ModelLoad$1 = (value) => value.steps;
export const ModelLoad$ModelLoad$deployments = (value) => value.deployments;
export const ModelLoad$ModelLoad$2 = (value) => value.deployments;
export const ModelLoad$ModelLoad$requests_per_minute = (value) =>
  value.requests_per_minute;
export const ModelLoad$ModelLoad$3 = (value) => value.requests_per_minute;
export const ModelLoad$ModelLoad$input_tokens_per_minute = (value) =>
  value.input_tokens_per_minute;
export const ModelLoad$ModelLoad$4 = (value) => value.input_tokens_per_minute;
export const ModelLoad$ModelLoad$output_tokens_per_minute = (value) =>
  value.output_tokens_per_minute;
export const ModelLoad$ModelLoad$5 = (value) => value.output_tokens_per_minute;
export const ModelLoad$ModelLoad$limits = (value) => value.limits;
export const ModelLoad$ModelLoad$6 = (value) => value.limits;
export const ModelLoad$ModelLoad$requests_pct = (value) => value.requests_pct;
export const ModelLoad$ModelLoad$7 = (value) => value.requests_pct;
export const ModelLoad$ModelLoad$tokens_pct = (value) => value.tokens_pct;
export const ModelLoad$ModelLoad$8 = (value) => value.tokens_pct;
export const ModelLoad$ModelLoad$input_tokens_pct = (value) =>
  value.input_tokens_pct;
export const ModelLoad$ModelLoad$9 = (value) => value.input_tokens_pct;
export const ModelLoad$ModelLoad$output_tokens_pct = (value) =>
  value.output_tokens_pct;
export const ModelLoad$ModelLoad$10 = (value) => value.output_tokens_pct;
export const ModelLoad$ModelLoad$status = (value) => value.status;
export const ModelLoad$ModelLoad$11 = (value) => value.status;

export const question_step = "ask_llm";

export const question_steps = /* @__PURE__ */ toList([
  "ask_llm",
  "agentic_retrieval",
  "compute_score",
  "style_output",
  "extract_question_and_instructions",
  "classify_answer",
  "compare_two_questions",
]);

export function questions(usage) {
  let _pipe = usage.steps;
  let _pipe$1 = $list.filter(
    _pipe,
    (step) => { return step.step === question_step; },
  );
  return $list.fold(_pipe$1, 0, (total, step) => { return total + step.calls; });
}

export function questions_per_proposal(usage) {
  let $ = usage.proposals;
  if ($ === 0) {
    return $;
  } else {
    let proposals = $;
    return divideInt(questions(usage), proposals);
  }
}

export function slots(scenario) {
  return scenario.servers * scenario.workers * scenario.answer_messages;
}

export function in_flight(scenario) {
  return $int.min(
    slots(scenario),
    scenario.proposals_in_parallel * scenario.questions_per_proposal,
  );
}

export function seconds_per_question(usage) {
  let $ = questions(usage);
  if ($ === 0) {
    return 0.0;
  } else {
    let questions$1 = $;
    let _pipe = usage.steps;
    let _pipe$1 = $list.filter(
      _pipe,
      (step) => { return $list.contains(question_steps, step.step); },
    );
    let _pipe$2 = $list.fold(
      _pipe$1,
      0.0,
      (total, step) => {
        return total + (step.p50_latency_s * $int.to_float(step.calls));
      },
    );
    return ((seconds) => {
      return divideFloat(seconds, $int.to_float(questions$1));
    })(_pipe$2);
  }
}

export function questions_per_minute(scenario) {
  let $ = scenario.seconds_per_question > 0.0;
  if ($) {
    return divideFloat(
      ($int.to_float(in_flight(scenario)) * 60.0),
      scenario.seconds_per_question
    );
  } else {
    return 0.0;
  }
}

export function waves(scenario) {
  let questions$1 = scenario.proposals_in_parallel * scenario.questions_per_proposal;
  let $ = slots(scenario);
  if ($ === 0) {
    return $;
  } else {
    let slots$1 = $;
    return divideInt(((questions$1 + slots$1) - 1), slots$1);
  }
}

export function seconds_per_proposal(scenario) {
  return $int.to_float(waves(scenario)) * scenario.seconds_per_question;
}

export function peak_pct(load) {
  let _pipe = toList([load.requests_pct, load.tokens_pct]);
  let _pipe$1 = $option.values(_pipe);
  let _pipe$2 = $list.max(_pipe$1, $float.compare);
  return $option.from_result(_pipe$2);
}

function status(peak_pct) {
  if (peak_pct instanceof Some) {
    let pct$1 = peak_pct[0];
    if (pct$1 >= 80.0) {
      return new NearLimit();
    } else {
      let pct$1 = peak_pct[0];
      if (pct$1 >= 60.0) {
        return new Watch();
      } else {
        return new WithinLimits();
      }
    }
  } else {
    return new LimitsUnknown();
  }
}

function pct(used, limit) {
  if (limit instanceof Some) {
    let limit$1 = limit[0];
    if (limit$1 > 0) {
      return new Some(divideFloat((100.0 * used), $int.to_float(limit$1)));
    } else {
      return new None();
    }
  } else {
    return new None();
  }
}

function summed_limits(deployments) {
  let _block;
  let _pipe = deployments;
  let _pipe$1 = $list.filter(
    _pipe,
    (deployment) => { return deployment.status instanceof $llm_capacity.Read; },
  );
  _block = $list.map(_pipe$1, (deployment) => { return deployment.limits; });
  let read = _block;
  let sum = (limit) => {
    let $ = $list.filter_map(
      read,
      (limits) => { return $option.to_result(limit(limits), undefined); },
    );
    if ($ instanceof $Empty) {
      return new None();
    } else {
      let values = $;
      return new Some($int.sum(values));
    }
  };
  return new RateLimits(
    sum((limits) => { return limits.rpm; }),
    sum((limits) => { return limits.tpm; }),
    sum((limits) => { return limits.itpm; }),
    sum((limits) => { return limits.otpm; }),
  );
}

function model_load(model_alias, steps, per_question, rate_limits) {
  let deployments = $list.filter(
    rate_limits,
    (rate_limit) => {
      return isEqual(new Some(rate_limit.model_alias), model_alias);
    },
  );
  let limits = summed_limits(deployments);
  let $ = $list.fold(
    steps,
    [0.0, 0.0, 0.0],
    (_use0, step) => {
      let calls = _use0[0];
      let input = _use0[1];
      let output = _use0[2];
      let step_calls = $int.to_float(step.calls);
      return [
        calls + step_calls,
        input + (step_calls * step.avg_input_tokens),
        output + (step_calls * step.avg_output_tokens),
      ];
    },
  );
  let calls = $[0];
  let input_tokens = $[1];
  let output_tokens = $[2];
  let requests = calls * per_question;
  let input_tokens$1 = input_tokens * per_question;
  let output_tokens$1 = output_tokens * per_question;
  let input_tokens_pct = pct(input_tokens$1, limits.itpm);
  let output_tokens_pct = pct(output_tokens$1, limits.otpm);
  let load = new ModelLoad(
    model_alias,
    (() => {
      let _pipe = steps;
      let _pipe$1 = $list.sort(
        _pipe,
        (a, b) => { return $int.compare(b.calls, a.calls); },
      );
      let _pipe$2 = $list.map(_pipe$1, (step) => { return step.step; });
      return $list.unique(_pipe$2);
    })(),
    $list.length(deployments),
    requests,
    input_tokens$1,
    output_tokens$1,
    limits,
    pct(requests, limits.rpm),
    (() => {
      if (input_tokens_pct instanceof Some && output_tokens_pct instanceof Some) {
        let input = input_tokens_pct[0];
        let output = output_tokens_pct[0];
        return new Some($float.max(input, output));
      } else {
        return pct(input_tokens$1 + output_tokens$1, limits.tpm);
      }
    })(),
    input_tokens_pct,
    output_tokens_pct,
    new LimitsUnknown(),
  );
  return new ModelLoad(
    load.model_alias,
    load.steps,
    load.deployments,
    load.requests_per_minute,
    load.input_tokens_per_minute,
    load.output_tokens_per_minute,
    load.limits,
    load.requests_pct,
    load.tokens_pct,
    load.input_tokens_pct,
    load.output_tokens_pct,
    status(peak_pct(load)),
  );
}

export function model_loads(scenario, usage, rate_limits) {
  let $ = questions(usage);
  if ($ === 0) {
    return toList([]);
  } else {
    let questions$1 = $;
    let per_question = divideFloat(
      questions_per_minute(scenario),
      $int.to_float(questions$1)
    );
    let _pipe = usage.steps;
    let _pipe$1 = $list.group(_pipe, (step) => { return step.model; });
    let _pipe$2 = $dict.to_list(_pipe$1);
    return $list.map(
      _pipe$2,
      (model) => {
        let model_alias = model[0];
        let steps = model[1];
        return model_load(model_alias, steps, per_question, rate_limits);
      },
    );
  }
}
